import AppContainer from './Dashboard';
import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import campaigns from './campaigns/campaigns.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import overviewRoutes from './overview/routes';

export default {
  routes: [
    ...helpcenterRoutes.routes,
    {
      path: frontendURL('accounts/:account_id'),
      component: AppContainer,
      children: [
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...campaigns.routes,
        ...searchRoutes,
        ...notificationRoutes,
        ...overviewRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      roles: ['administrator', 'agent'],
      component: () => import('./suspended/Index'),
    },
    {
      path: frontendURL('accounts/:accountId/inactivated'),
      name: 'account_inactivated',
      roles: ['administrator', 'agent'],
      component: () => import('./inactivated/Index'),
    },
  ],
};
